import React from 'react';
import { Spinner } from 'react-bootstrap';

import { useLocalization } from '../contexts/LocalizationContext';

export default function Loading({
  position = 'absolute-center',
  options = null
}) {
  const { localize } = useLocalization();
  const styles =
    position === 'absolute-center'
      ? {
          position: 'fixed',
          top: '50vh',
          left: '50vw',
          zIndex: '1000',
          transform: 'translate(-50%, -50%)'
        }
      : position === 'card'
      ? {
          display: 'grid',
          placeItems: 'center',
          alignItems: 'center',
          height: '100%'
        }
      : position === 'content-center'
      ? {
          position: 'fixed',
          top: '50%',
          left: '50%',
          // transform: 'translate(-50%, -50%)'
        }
      : null;

  let optionProps = { variant: 'dark', animation: 'border', role: 'status' };
  if (options) optionProps = { ...optionProps, ...options };

  return (
    <>
      {styles ? (
        <div style={styles}>
          <Spinner {...optionProps}>
            <span className='visually-hidden'>
              {/* {localize('common.loading')} */}
            </span>
          </Spinner>
        </div>
      ) : (
        <Spinner {...optionProps}>
          <span className='visually-hidden'>{localize('common.loading')}</span>
        </Spinner>
      )}
    </>
  );
}
